// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-styles-components-___ConfirmationDialog__modal-backdrop___OMDDd {
  position: fixed;
  top: 0;
  left: 0;
  min-width: 100% !important;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}
.src-styles-components-___ConfirmationDialog__modal___jzYpi {
  background: white;
  padding: 20px;
  border-radius: 8px;
  position: fixed;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -30%);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}
.src-styles-components-___ConfirmationDialog__modal-input___nQbiE {
  margin-top: 10px;
  margin-bottom: 10px;
}
.src-styles-components-___ConfirmationDialog__modal-input___nQbiE input {
  width: 100%;
  padding: 6px;
  margin-top: 4px;
}
.src-styles-components-___ConfirmationDialog__modal-buttons___DvK71 {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/ConfirmationDialog.less"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,0BAAA;EACA,YAAA;EACA,8BAAA;AACJ;AAEE;EACE,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,yCAAA;AAAJ;AAGE;EACE,gBAAA;EACA,mBAAA;AADJ;AAIE;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAFJ;AAKE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;AAHJ","sourcesContent":[".modal-backdrop {\n    position: fixed;\n    top: 0;\n    left: 0;\n    min-width: 100% !important;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.5);\n  }\n  \n  .modal {\n    background: white;\n    padding: 20px;\n    border-radius: 8px;\n    position: fixed;\n    top: 30%;\n    left: 50%;\n    transform: translate(-50%, -30%);\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);\n  }\n\n  .modal-input {\n    margin-top: 10px;\n    margin-bottom: 10px;\n  }\n  \n  .modal-input input {\n    width: 100%;\n    padding: 6px;\n    margin-top: 4px;\n  }\n  \n  .modal-buttons {\n    display: flex;\n    justify-content: flex-end;\n    gap: 10px;\n  }\n\n"],"sourceRoot":""}]);
// Exports
var _1 = `src-styles-components-___ConfirmationDialog__modal-backdrop___OMDDd`;
export { _1 as "modal-backdrop" };
export var modal = `src-styles-components-___ConfirmationDialog__modal___jzYpi`;
var _2 = `src-styles-components-___ConfirmationDialog__modal-input___nQbiE`;
export { _2 as "modal-input" };
var _3 = `src-styles-components-___ConfirmationDialog__modal-buttons___DvK71`;
export { _3 as "modal-buttons" };
export default ___CSS_LOADER_EXPORT___;
